@let vm = recommendationsVm$ | async;
@if (vm; as cartVm) {
  @let recommendations = recommendationsForDisplay(cartVm.recommendations);
  @if (recommendations.length > 0) {
    <div class="mx-auto max-w-md lg:mx-auto lg:max-w-4xl lg:px-0">
      <div class="mx-auto max-w-md px-5 pb-2 lg:max-w-full lg:px-0 lg:pb-2">
        @if (heading() || leading()) {
          <div class="flex items-center justify-between">
            @if (heading()) {
              <h2 class="font-accent text-2xl font-bold text-neutral-800 lg:text-3xl">
                {{ heading() }}
              </h2>
              @if (!isMobile()) {
                <div class="hidden lg:block">
                  <app-rounded-icon-button
                    [size]="'xs'"
                    [disabled]="currentIndex === 0"
                    [type]="'light'"
                    [icon]="'icon-arrow-left'"
                    (click)="prev()"
                  ></app-rounded-icon-button>
                  <app-rounded-icon-button
                    class="ml-2"
                    [disabled]="currentIndex >= recommendations.length - nbDisplayCards"
                    [size]="'xs'"
                    [type]="'light'"
                    [icon]="'icon-arrow-right'"
                    (click)="next()"
                  ></app-rounded-icon-button>
                </div>
              }
            }
            @if (leading()) {
              <p class="mt-1 font-base text-sm text-neutral-600 md:text-base">
                {{ leading() }}
              </p>
            }
          </div>
        }
      </div>
      @if (isMobile()) {
        <ul class="flex overflow-x-auto px-5 pb-8 scrollbar-hide lg:px-0 lg:pb-12">
          @for (recommendation of recommendations; track productOf(recommendation).id) {
            <li class="ml-1 mr-3 w-10 min-w-10 flex-shrink-0 flex-grow-0 lg:w-52 lg:min-w-52">
              @if (recommendation.type === 'product') {
                <app-product-card-atom
                  displayContext="suggestion"
                  [product]="productOf(recommendation)"
                  (productClick)="productClick(productOf(recommendation))"
                ></app-product-card-atom>
              }
            </li>
          }
        </ul>
      }
      @if (!isMobile()) {
        <app-card-carousel
          [cards]="recommendations"
          [nbDisplayCards]="nbDisplayCards"
          [carouselItem]="productTemplate"
          [externalIndex]="currentIndex"
          [hideArrows]="true"
        ></app-card-carousel>
        <ng-template
          #productTemplate
          let-recommendation
        >
          <div class="flex-1 min-w-0">
            @if (recommendation.type === 'product') {
              <app-product-card-atom
                displayContext="suggestion"
                [product]="productOf(recommendation)"
                [cardHeight]="'small'"
                (productClick)="productClick(productOf(recommendation))"
              ></app-product-card-atom>
            }
          </div>
        </ng-template>
      }
    </div>
  }
}
